var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g3, _g4, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g5, _path25, _path26, _path27, _path28, _path29, _path30, _g6, _path31, _path32, _path33, _path34, _path35, _path36, _g7, _path37, _path38, _path39, _path40, _path41, _path42, _g8, _g9, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _g10, _path55, _path56, _path57, _path58, _path59, _path60, _g11, _path61, _path62, _path63, _path64, _path65, _path66, _g12, _g13, _path67, _path68, _path69, _path70, _path71, _path72;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopLg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1914,
    height: 871,
    viewBox: "0 0 1914 871",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M570.188 408.715L436.354 485.884L120.443 302.607L259.112 225.438L570.188 408.715Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.289 413.917L299.407 438.199L398.813 380.522L355.183 356.24L257.289 413.917Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.289 542.151L299.407 566.433L398.813 508.767L355.183 484.485L257.289 542.151Z",
    stroke: "#231F20",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.534 542.151L299.641 566.433L399.047 508.767L355.417 484.485L257.534 542.151Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.407 438.198V566.432",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.794 356.24V484.485L398.769 508.722V380.478",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.289 413.494V541.727",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.607 356.397L216.726 380.679L316.121 323.013L272.491 298.731L174.607 356.397Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M174.607 484.641L216.726 508.923L316.121 451.246L272.491 426.964L174.607 484.641Z",
    stroke: "#231F20",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M174.853 484.641L216.96 508.923L316.366 451.246L272.736 426.964L174.853 484.641Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M216.726 380.68V508.924",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M272.114 298.731V426.965L316.088 451.202V322.969",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M174.607 355.974V484.218",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6924 301.788L127.8 326.07L227.206 268.393L183.576 244.111L85.6924 301.788Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6924 430.023L127.8 454.305L227.206 396.639L183.576 372.357L85.6924 430.023Z",
    stroke: "#231F20",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9258 430.023L128.044 454.305L227.45 396.639L183.809 372.357L85.9258 430.023Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M127.8 326.07V454.304",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M183.199 244.111V372.356L227.162 396.593V268.36",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6924 301.365V429.599",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 244.265L45.1184 268.547L144.525 210.882L100.895 186.6L3 244.265Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 372.511L45.1184 396.793L144.525 339.128L100.895 314.846L3 372.511Z",
    stroke: "#231F20",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.24463 372.511L45.3631 396.793L144.758 339.128L101.128 314.846L3.24463 372.511Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1187 268.548V396.792",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.517 186.6V314.844L144.48 339.082V210.837",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 243.842V372.086",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M547.85 245.233L589.957 269.515L689.363 211.849L645.733 187.567L547.85 245.233Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.85 373.476L589.957 397.759L689.363 340.082L645.733 315.8L547.85 373.476Z",
    stroke: "#231F20",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.083 373.476L590.201 397.759L689.608 340.082L645.978 315.8L548.083 373.476Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.957 269.516V397.76",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.355 187.567V315.801L689.319 340.038V211.805",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.85 244.81V373.054",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M466.136 197.469L508.255 221.751L607.661 164.086L564.031 139.804L466.136 197.469Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M466.136 325.714L508.255 349.996L607.661 292.319L564.031 268.037L466.136 325.714Z",
    stroke: "#231F20",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M466.381 325.714L508.488 349.996L607.894 292.319L564.265 268.037L466.381 325.714Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M508.254 221.752V349.997",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M563.642 139.804V268.037L607.616 292.275V164.041",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M466.136 197.046V325.29",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M377.221 142.857L419.328 167.139L518.734 109.463L475.104 85.1807L377.221 142.857Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M377.221 271.092L419.328 295.374L518.734 237.709L475.104 213.427L377.221 271.092Z",
    stroke: "#231F20",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M377.454 271.092L419.573 295.374L518.979 237.709L475.349 213.427L377.454 271.092Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M419.328 167.14V295.373",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M474.727 85.1807V213.425L518.69 237.663V109.429",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M377.221 142.435V270.668",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.506 96.063L337.625 120.345L437.031 62.6795L393.401 38.3975L295.506 96.063Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.506 224.309L337.625 248.591L437.031 190.926L393.401 166.644L295.506 224.309Z",
    stroke: "#231F20",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.751 224.309L337.869 248.591L437.264 190.926L393.635 166.644L295.751 224.309Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.625 120.346V248.59",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.023 38.3975V166.642L436.987 190.88V62.635",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.506 95.6523V223.886",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M948.788 403.006L906.669 427.288L807.263 369.611L850.893 345.329L948.788 403.006Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M948.788 531.24L906.669 555.522L807.263 497.856L850.893 473.574L948.788 531.24Z",
    stroke: "#231F20",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M948.543 531.24L906.436 555.522L807.03 497.856L850.66 473.574L948.543 531.24Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M906.67 427.288V555.522",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M851.282 345.329V473.574L807.308 497.811V369.578",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M948.788 402.582V530.815",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1302.25 711.314L1168.41 788.483L852.504 605.207L991.173 528.038L1302.25 711.314Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M864.951 450.392L822.843 474.675L723.437 416.998L767.067 392.716L864.951 450.392Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.951 578.628L822.843 602.91L723.437 545.244L767.067 520.962L864.951 578.628Z",
    stroke: "#231F20",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.717 578.628L822.599 602.91L723.193 545.244L766.823 520.962L864.717 578.628Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.844 474.675V602.908",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.445 392.716V520.96L723.481 545.198V416.953",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.951 449.97V578.203",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.3 467.129L1175.18 491.411L1075.78 433.734L1119.42 409.452L1217.3 467.129Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.3 595.363L1175.18 619.645L1075.78 561.979L1119.42 537.697L1217.3 595.363Z",
    stroke: "#231F20",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.06 595.363L1174.95 619.645L1075.54 561.979L1119.17 537.697L1217.06 595.363Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1175.18 491.411V619.645",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1119.8 409.452V537.697L1075.82 561.934V433.69",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.3 466.706V594.939",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1347.8 539.475L1305.68 563.757L1206.28 506.092L1249.92 481.81L1347.8 539.475Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.8 667.719L1305.68 692.001L1206.28 634.324L1249.92 610.042L1347.8 667.719Z",
    stroke: "#231F20",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.56 667.719L1305.45 692.001L1206.04 634.324L1249.67 610.042L1347.56 667.719Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305.68 563.758V692.002",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.3 481.81V610.043L1206.32 634.281V506.047",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.8 539.052V667.296",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M983.027 380.39L1025.15 404.672L1124.54 347.007L1080.91 322.725L983.027 380.39Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M983.027 508.634L1025.15 532.916L1124.54 475.239L1080.91 450.957L983.027 508.634Z",
    stroke: "#231F20",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M983.261 508.634L1025.38 532.916L1124.79 475.239L1081.16 450.957L983.261 508.634Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1025.15 404.673V532.917",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1080.53 322.725V450.958L1124.51 475.196V346.962",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M983.027 379.968V508.212",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M890.344 322.613L932.463 346.895L1031.87 289.219L988.228 264.937L890.344 322.613Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.344 450.846L932.463 475.128L1031.87 417.463L988.228 393.181L890.344 450.846Z",
    stroke: "#231F20",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.589 450.846L932.696 475.128L1032.1 417.463L988.473 393.181L890.589 450.846Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.851 264.937V393.181L1031.82 417.419V289.185",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.344 450.424V322.19L932.463 346.895V475.128",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M989.35 716.504L1031.47 740.786L1130.87 683.121L1087.24 658.839L989.35 716.504Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.35 844.748L1031.47 869.03L1130.87 811.353L1087.24 787.071L989.35 844.748Z",
    stroke: "#231F20",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.595 844.748L1031.7 869.03L1131.11 811.353L1087.48 787.071L989.595 844.748Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.47 740.787V869.032",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.86 658.839V787.072L1130.83 811.31V683.076",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.35 716.081V844.326",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M906.669 658.994L948.787 683.276L1048.19 625.599L1004.55 601.317L906.669 658.994Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M906.669 787.229L948.787 811.511L1048.19 753.845L1004.55 729.563L906.669 787.229Z",
    stroke: "#231F20",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M906.914 787.229L949.021 811.511L1048.43 753.845L1004.8 729.563L906.914 787.229Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M948.788 683.276V811.51",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1004.17 601.317V729.562L1048.15 753.799V625.566",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M906.669 658.572V786.806",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1911 338.006L1868.89 362.288L1769.49 304.623L1813.12 280.341L1911 338.006Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1911 466.251L1868.89 490.533L1769.49 432.856L1813.12 408.574L1911 466.251Z",
    stroke: "#231F20",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1910.77 466.251L1868.65 490.533L1769.24 432.856L1812.88 408.574L1910.77 466.251Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1868.89 362.289V490.534",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1813.49 280.341V408.574L1769.53 432.812V304.578",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1911 337.584V465.829",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1799.29 390.148L1665.46 467.317L1349.55 284.041L1488.21 206.872L1799.29 390.148Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1839.92 387.937L1797.8 412.219L1698.4 354.553L1742.03 330.271L1839.92 387.937Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1839.68 516.181L1797.57 540.463L1698.16 482.786L1741.79 458.504L1839.68 516.181Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1797.8 412.22V540.464",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742.41 330.271V458.505L1698.44 482.742V354.509",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1839.92 387.514V515.758",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1714.34 145.962L1672.22 170.244L1572.82 112.567L1616.46 88.2852L1714.34 145.962Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1714.34 274.196L1672.22 298.478L1572.82 240.812L1616.46 216.53L1714.34 274.196Z",
    stroke: "#231F20",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1714.1 274.196L1671.99 298.478L1572.59 240.812L1616.22 216.53L1714.1 274.196Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1672.22 170.244V298.478",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1616.84 88.2852V216.53L1572.86 240.767V112.534",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1714.34 145.539V273.772",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1844.84 218.309L1802.73 242.591L1703.32 184.926L1746.95 160.644L1844.84 218.309Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1844.84 346.553L1802.73 370.835L1703.32 313.158L1746.95 288.876L1844.84 346.553Z",
    stroke: "#231F20",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1844.6 346.553L1802.49 370.835L1703.09 313.158L1746.72 288.876L1844.6 346.553Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1802.73 242.592V370.836",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1747.34 160.644V288.877L1703.36 313.126V184.881",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1844.84 217.886V346.13",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1480.07 59.2242L1522.18 83.5062L1621.58 25.8406L1577.95 1.55859L1480.07 59.2242Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1480.07 187.468L1522.18 211.75L1621.58 154.073L1577.95 129.791L1480.07 187.468Z",
    stroke: "#231F20",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1480.3 187.468L1522.42 211.75L1621.83 154.073L1578.2 129.791L1480.3 187.468Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1522.18 83.5068V211.751",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1577.57 1.55859V129.792L1621.54 154.041V25.7961",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1480.07 58.8008V187.045",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1319.84 286.931L1361.95 311.213L1461.35 253.536L1417.73 229.254L1319.84 286.931Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1319.84 415.165L1361.95 439.447L1461.35 381.781L1417.73 357.499L1319.84 415.165Z",
    stroke: "#231F20",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.07 415.165L1362.19 439.447L1461.6 381.781L1417.97 357.499L1320.07 415.165Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1417.35 229.254V357.498L1461.32 381.736V253.503",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1319.84 414.742V286.509L1361.95 311.213V439.446",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1486.39 395.339L1528.51 419.621L1627.92 361.956L1584.28 337.674L1486.39 395.339Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1486.39 523.583L1528.51 547.865L1627.92 490.188L1584.28 465.906L1486.39 523.583Z",
    stroke: "#231F20",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1486.64 523.583L1528.74 547.865L1628.15 490.188L1584.52 465.906L1486.64 523.583Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1528.51 419.622V547.867",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1583.9 337.674V465.907L1627.87 490.156V361.911",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1486.39 394.917V523.162",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1403.71 337.828L1445.83 362.11L1545.22 304.444L1501.59 280.162L1403.71 337.828Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1403.71 466.06L1445.83 490.342L1545.22 432.677L1501.59 408.395L1403.71 466.06Z",
    stroke: "#231F20",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1403.96 466.06L1446.06 490.342L1545.47 432.677L1501.84 408.395L1403.96 466.06Z",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1445.83 362.11V490.344",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1501.22 280.162V408.396L1545.19 432.633V304.4",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1403.71 337.404V465.638",
    stroke: "white",
    strokeWidth: 2.54489,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopLg);
export default __webpack_public_path__ + "static/media/desktop-lg.b57b6eacac94559fa9c2eb31b1c3f1a4.svg";
export { ForwardRef as ReactComponent };